export const BUY_LINK = [
  {
    link:"https://pancakeswap.finance/swap?outputCurrency=0x50C7584be73D20760f1947fFcbF7942822C968C8"
  }
]
export const Partner = [
  {
    name: "certik",
    h: 40,
    link:"https://skynet.certik.com/projects/trust-ai"
  },
  {
    name: "Chainlink",
    h: 38,
    link:"https://chain.link/badge-cross-chain-black"
  },
  {
    name: "Dextools",
    h: 40,
    link:"https://www.dextools.io/app/en/bnb/pair-explorer/0xe74957964006d46bd198656bd9f3d2a05afe9747"
  },
  {
    name: "BinanceSmartChain",
    h: 40,
    link:"https://bscscan.com/address/0x50C7584be73D20760f1947fFcbF7942822C968C8"
  },
  {
    name: "Pancakeswap",
    h: 33,
    link:"https://pancakeswap.finance/swap?outputCurrency=0x50C7584be73D20760f1947fFcbF7942822C968C8"
  },
  {
    name: "Poocoin",
    h: 37,
    link:"https://poocoin.app/tokens/0x50C7584be73D20760f1947fFcbF7942822C968C8"
  },
  {
    name: "dexview",
    h: 34.5,
    link:"https://www.dexview.com/bsc/0x50C7584be73D20760f1947fFcbF7942822C968C8"
  },
  {
    name: "Pinksale",
    h: 37,
    link:"https://www.pinksale.finance/launchpad/0x1D94b4827611EF4B6e9c91a3938862Cb6b8905CB?chain=BSC"
  },
];

export const Supply_label = [
  {
    name: "Presale",
    share: 35,
    color:"#D9A200"
  },
  {
    name: "Exchange & Liquidity",
    share: 25,
    color:"#CDAA46 "
  },
  {
    name: "Eco System",
    share: 10,
    color:"#FFD600"
  },
  {
    name: "Marketing",
    share: 10,
    color:"#D2C686 "
  },
  {
    name: "Partneships",
    share: 10,
    color:"#FDE290 "
  },
  {
    name: "Rewarding System",
    share: 10,
    color:"#DEEBBC"
  },
];

export const Token_Info = [
  {
    label: "Token name",
    ans: "Trust",
  },
  {
    label: "Ticker Symbol",
    ans: "TRT",
  },
  {
    label: "Chain",
    ans: "BNB Smart Chain BEP20",
  },
  {
    label: "Buy & Sell Tax",
    ans: "5%",
  },
];

export const Features_box = [
  {
    iconName: 1,
    text: "AI GENERATE Artwork.",
  },
  {
    iconName: 2,
    text: "Smart Contract Inegration",
  },
  {
    iconName: 1,
    text: "Blockchain Compatibility",
  },
  {
    iconName: 3,
    text: "User-Friendly Interface",
  },
];

//fotter

export const service_manu = [
  {
    name: "TRT Explorer",
    link: "https://trust-ai.io/coming-soon.html",
    islink: true,
    comingsoon: false,
  },

  {
    name: "TRT Wallet",
    link: "https://trust-ai.io/coming-soon.html",
    islink: true,
    comingsoon: false,
  },
  {
    name: "NFT AI",
    link: "/nftai",
    islink: false,
    comingsoon: false,
  },
  {
    name: "Create Token",
    link: "/createTokenmaker",
    islink: false,
    comingsoon: false,
  },
  {
    name:"TRT Swap (DEX)",
    link: "/swap",
    islink: false,
    comingsoon: false,
  }
];

export const resource_manu = [
  {
    name: "White Paper",
    link: "https://trust-ai-1.gitbook.io/whitepaper-trust-ai/",
    islink: true,
    comingsoon: false,
  },

  {
    name: "GitHub",
    link: "https://github.com/TRUSTAIOFFICIAL",
    islink: true,
    comingsoon: false,
  },
  // {
  //   name: "Roadmap",
  //   link: "/",
  //   islink: false,
  //   comingsoon: false,
  // },
  {
    name: "Documentation",
    link: "https://trust-ai-1.gitbook.io/whitepaper-trust-ai/overview/our-ecosystem",
    islink: true,
    comingsoon: false,
  },
];

export const community_manu = [
  {
    name: "Telegram",
    link: "https://t.me/TRUST_AI_OFFICIAL",
    islink: true,
    comingsoon: false,
  },

  {
    name: "X (Twitter)",
    link: "https://twitter.com/TRUST_AI_",
    islink: true,
    comingsoon: false,
  },
 
];

export const social_manu = [
  {
    name:"telegram",
    link:"https://t.me/TRUST_AI_OFFICIAL"
  },
  {
    name:"twitter",
    link:"https://twitter.com/TRUST_AI_?ref_src=twsrc%5Etfw%7Ctwcamp%5Etweetembed%7Ctwterm%5E1659997493046788097%7Ctwgr%5E96654fb8f40576cedad5873a146f607811951414%7Ctwcon%5Es1_&ref_url=https%3A%2F%2Flinktr.ee%2Ftrustai"
  }
  ,
  {
    name:"instagram",
    link:"https://www.instagram.com/trust_ai_/?igshid=ZGUzMzM3NWJiOQ%3D%3D&__coig_restricted=1"
  },
  {
    name:"reddit",
    link:"https://www.reddit.com/user/TRUST-AI/"
  },  {
    name:"github",
    link:"https://github.com/TRUSTAIOFFICIAL"
  },
]



// 
export const Roadmap = [
  {
    name: "Milestones 1",
    data: [
      { name: "Website & Smart Contract Testing",isDone:true },
      { name: "Audit and KYC",isDone:true  },
      { name: "Fairlaunch on Pinksale" ,isDone:true },
      { name: "Launch on Pinksale" ,isDone:true },
      { name: "Big Marketing Campaign",isDone:true  },
      { name: "Dextools Update" ,isDone:true },
    ],

  },
  {
    name: "Second Milestones2",
    data: [
      { name: "500 Holders Milestone" ,isDone:true },
      { name: "Website Update" ,isDone:true },
      { name: "Massive Marketing",isDone:true  },
      { name: "Strong Partnership" ,isDone:true },
      { name: "Listing on CMC",isDone:true  },
      { name: "Listing on CEX" ,isDone:true },
    ],
  },
  {
    name: "Third Milestones3",
    data: [
      { name: "1000 Holders Milestone" ,isDone:true },
      { name: "Strong Marketing",isDone:true  },
      { name: "Strong Partnership",isDone:true  },
      { name: "Listing on CEX",isDone:true  },
      { name: "Listing on CG",isDone:true  },
      { name: "Certik" ,isDone:true },
    ],
  },
  {
    name: "Fourth Milestones4",
    data: [
      { name: "Start TRUST AI",isDone:false  },
      { name: "2500+ Holders Milestone",isDone:false  },
      { name: "Website V3",isDone:false  },
      { name: "SWAP. Adding Language" ,isDone:false },
      { name: "Create smart contracts",isDone:false  },
      { name: "NFT AI" ,isDone:false },
      // { name: "Merge Image AI",isDone:false  },
    ],
  },
  {
    name: "Fifth Milestones5",
    data: [
      { name: "7000+ Holders Milestone" ,isDone:false },
      { name: "Website V4" ,isDone:false },
      { name: "Wallet AI and Mobile App",isDone:false  },
      { name: "Listing on CEX" ,isDone:false },
      { name: "Sponsoring Agreement" ,isDone:false },
    ],
  },
  {
    name: "Sixth Milestones",
    data: [
      { name: "10000+ Holders Milestone" ,isDone:false },
      { name: "BlockchainAI",isDone:false  },
    ],
  }
  
  
  
]